import { render, staticRenderFns } from "./checklistTemplate.vue?vue&type=template&id=dc8c09d4&scoped=true"
import script from "./checklistTemplate.vue?vue&type=script&lang=js"
export * from "./checklistTemplate.vue?vue&type=script&lang=js"
import style0 from "./checklistTemplate.vue?vue&type=style&index=0&id=dc8c09d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8c09d4",
  null
  
)

export default component.exports